// ==========================================
// Base API URL
// ==========================================
const API_BASE_URL = 'https://websiteapi.musclesquad.co.uk';
// const API_BASE_URL = 'https://207c-103-151-156-13.ngrok-free.app';

// ==========================================
// Reusable Helper Functions (Validation)
// ==========================================
function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function isValidMobile(mobile) {
  // Allows only numbers, spaces, and the '+' symbol
  const mobileRegex = /^[0-9+\s]+$/;
  return mobileRegex.test(mobile);
}

// ==========================================
// Reusable Submit Functions (with ngrok header)
// ==========================================
async function submitHomeForm({ fullName, email, mobileNumber, additionalInfo, trainingLocation }) {
  const endpoint = `${API_BASE_URL}/push-home-form-klaviyo`;

  const payload = { fullName, email, mobileNumber, additionalInfo, trainingLocation };

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true"     // ← Added for ngrok
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.isSuccess) {
      console.log("✅ Home form submitted:", result);
      return {
        isSuccess: true,
        message: "Thank you for contacting us. We will get back to you shortly.",
        data: result,
        submittedPayload: payload
      };
    } else {
      throw new Error(result.message || "Failed to save form.");
    }
  } catch (error) {
    console.error("❌ Home form error:", error);
    return {
      isSuccess: false,
      message: error.message || "Something went wrong. Please try again.",
      error
    };
  }
}

async function submitProductForm({
  fullName, email, mobileNumber, trainingLocation,
  trainingStartTime, trainingBudget, trainingMoreInfo, contactPreference
}) {
  const endpoint = `${API_BASE_URL}/push-product-form-custom`;

  const payload = {
    fullName, email, mobileNumber, trainingLocation,
    trainingStartTime, trainingBudget, trainingMoreInfo, contactPreference
  };

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true"     // ← Added for ngrok
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (result.isSuccess) {
      console.log("✅ Product form submitted:", result);
      return {
        isSuccess: true,
        message: "Thank you for contacting us. We will get back to you shortly.",
        data: result,
        submittedPayload: payload
      };
    } else {
      throw new Error(result.Message || "Failed to save form.");
    }
  } catch (error) {
    console.error("❌ Product form error:", error);
    return {
      isSuccess: false,
      message: error.message || "Something went wrong. Please try again.",
      error
    };
  }
}

// ==========================================
// Global Click Handler
// ==========================================
document.addEventListener("click", async function (e) {

  // === Home Form Submit ===
  if (e.target.closest(".homeFormSubmit")) {
    e.preventDefault();

    const emailValue = document.querySelector("#homeEmail")?.value.trim() || "";
    const mobileValue = document.querySelector("#homeMobile")?.value.trim() || "";

    // 🛑 Home Form Validation: Email format check
    if (!emailValue) {
      alert("Please enter your email address.");
      return;
    }
    if (!isValidEmail(emailValue)) {
      alert("Please enter a valid email address.");
      return;
    }

    // 🛑 Home Form Validation: Mobile number format check (only if not empty)
    if (mobileValue && !isValidMobile(mobileValue)) {
      alert("Please enter a valid mobile number (only numbers, spaces, and '+' are allowed).");
      return;
    }

    const btn = e.target.closest(".homeFormSubmit");
    const originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = "Submitting...";

    const payload = {
      fullName: document.querySelector("#homeFullName")?.value.trim() || "",
      email: emailValue,
      mobileNumber: mobileValue,
      additionalInfo: "Home Page Form",
      trainingLocation: document.querySelector("#homeAdditional")?.value.trim() || ""
    };

    const result = await submitHomeForm(payload);

    btn.disabled = false;
    btn.textContent = originalText;

    if (result.isSuccess) {
      // 🔥 Trigger discount-close button
      setTimeout(() => {
        const closeBtn = document.querySelector(".discount-close");
        if (closeBtn) {
          closeBtn.click();
        }
      }, 2000);
      
      // Hide the elements
      document.getElementById("home-promo-form").style.display = "none";

      // Show the thank you message
      document.getElementById("home-thank-you").style.display = "block";

      document.querySelector("#homeFullName").value = "";
      document.querySelector("#homeEmail").value = "";
      document.querySelector("#homeMobile").value = "";
      document.querySelector("#homeAdditional").value = "";
    }
  }

  // === Product Form Submit ===
  if (e.target.closest(".productFormSubmit")) {
    e.preventDefault();

    const nameValue = document.querySelector("#productFullName")?.value.trim() || "";
    const emailValue = document.querySelector("#productEmail")?.value.trim() || "";
    const phoneValue = document.querySelector("#productMobile")?.value.trim() || "";

    // 🛑 Product Form Validation: Name, Email, Phone Mandatory
    if (!nameValue) {
      alert("Please enter your full name.");
      return;
    }
    if (!emailValue) {
      alert("Please enter your email address.");
      return;
    }
    if (!isValidEmail(emailValue)) {
      alert("Please enter a valid email address.");
      return;
    }
    if (!phoneValue) {
      alert("Please enter your mobile number.");
      return;
    }
    // 🛑 Product Form Validation: Mobile character format check
    if (!isValidMobile(phoneValue)) {
      alert("Please enter a valid mobile number (only numbers, spaces, and '+' are allowed).");
      return;
    }

    const btn = e.target.closest(".productFormSubmit");
    const originalText = btn.textContent;

    btn.disabled = true;
    btn.textContent = "Submitting...";

    const payload = {
      fullName: nameValue,
      email: emailValue,
      mobileNumber: phoneValue,
      trainingLocation: document.querySelector("#trainingLocation")?.value.trim() || "Room within the house",
      trainingStartTime: document.querySelector("#trainingStartTime")?.value.trim() || "Now within 4 weeks",
      trainingBudget: document.querySelector("#trainingBudget")?.value || '0 to 999',
      trainingMoreInfo: document.querySelector("#trainingMoreInfo")?.value.trim() || "",
      contactPreference: document.querySelector("#contactMode")?.value.trim() || ""
    };

    console.log(payload);

    const result = await submitProductForm(payload);


    btn.disabled = false;
    btn.textContent = originalText;

    if (result.isSuccess) {

      // 🔥 Trigger discount-close button
      setTimeout(() => {
        const closeBtn = document.querySelector(".close-popup");
        if (closeBtn) {
          closeBtn.click();
        }
      }, 2000);
      
      // Hide the elements
      document.getElementById("btnProductSubmit").style.display = "none";

      // Show the thank you message
      document.getElementById("product-page-thank-you").style.display = "block";
      document.querySelector("#productFullName").value = "";
      document.querySelector("#productEmail").value = "";
      document.querySelector("#productMobile").value = "";
    }
  }
});